import { cva, type VariantProps } from "class-variance-authority";
import type { ComponentProps } from "react";

import { cn } from "@/lib/utils/cn";

const alertVariants = cva("flex items-start gap-3 rounded-lg border px-4 py-3 text-sm [&_svg]:mt-0.5 [&_svg]:size-4", {
    variants: {
        variant: {
            default: "bg-card text-card-foreground",
            destructive: "border-destructive/50 text-destructive",
        },
    },
    defaultVariants: { variant: "default" },
});

export function Alert({ className, variant, ...props }: ComponentProps<"div"> & VariantProps<typeof alertVariants>) {
    return <div role="alert" className={cn(alertVariants({ variant }), className)} {...props} />;
}
